// extracted by mini-css-extract-plugin
export default {"titleWrapper":"SOKqw","title":"hNqEJ","tooltip":"llUF3","titleIcon":"U4jNt","list":"sQtch","noUserFullNameNotice":"wUFZo"};